var map = {
	"./bind-equipment.png": 9660,
	"./close-active.png": 64313,
	"./close.png": 95248,
	"./close2.png": 28352,
	"./download.png": 56366,
	"./export-fail.png": 59859,
	"./export-prepare.png": 49990,
	"./export-success.png": 73718,
	"./fullscreen-mode-black.png": 2279,
	"./fullscreen-mode-white.png": 73953,
	"./keyboard-active.png": 4750,
	"./keyboard.png": 92773,
	"./logoff-active.png": 48328,
	"./logoff.png": 1563,
	"./max.png": 8650,
	"./menu-icon.png": 91261,
	"./menu-icon2.png": 93787,
	"./min.png": 37076,
	"./min2.png": 3804,
	"./paper-collect-active.png": 46576,
	"./paper-collect.png": 20499,
	"./recovery.png": 86547,
	"./reduction-active.png": 25748,
	"./reduction.png": 78015,
	"./return-active.png": 58545,
	"./return.png": 41592,
	"./school-icon.png": 61186,
	"./school-left.png": 41602,
	"./school-right.png": 14303,
	"./timer-active.png": 52064,
	"./timer-list-bottom-side.png": 20570,
	"./timer-list-top-side.png": 53166,
	"./timer.png": 29859,
	"./toggle-active.png": 86155,
	"./toggle.png": 23302,
	"./user.png": 50955,
	"./window-mode-black.png": 53206,
	"./window-mode-white.png": 35512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52169;